module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/aoj_b-1-ca88b7b6cd8ecfcc56402f4bcd073e82.jpg";